import React from "react";
import { useEditorState } from "@/store";
import { getGodotBaseUrl } from "@/utils";

export const GodotFrame: React.FC<any> = ({ module, title }) => {
  const { project, metadata, godotContainerRef, language, backwardCompatibility, configJson } = useEditorState();

  const base = getGodotBaseUrl(project?.stembox_branch);
  let src = import.meta.env.VITE_GODOT_DEV_URL
    ? `${base}/index.html?contentId=${project?.project_id
    }&language=${language}${metadata?.is_preview ? "&preview=true" : ""}&enableEditorEventLogs`
    : `${base}/index.html?containerless&contentId=${project?.project_id
    }&language=${language}${metadata?.is_preview ? "&preview=true" : ""}`;

  if (backwardCompatibility) {
    if (configJson?.simulationUrl) {
      const url = new URL(configJson.simulationUrl);
      const params = url.searchParams;

      if (params.has("language")) {
        params.set("language", language.toLowerCase());
      } else {
        params.append("language", language.toLowerCase());
      }

      if (metadata?.is_preview) {
        params.set("preview", "true");
      }

      if (params.has("module")) {
        params.set("module", module);
      } else {
        params.append("module", module);
      }

      src = url.toString();
    }
  }

  return (
    <div className={`w-full h-full relative no-scrollbar`}>
      <iframe
        id="simulation-iframe"
        className={`w-full h-full no-scrollbar`}
        title={title}
        allowFullScreen
        allow="cross-origin-isolated; clipboard-read; clipboard-write; camera *; microphone *; autoplay *;"
        ref={godotContainerRef}
        src={src}
      />
    </div>
  );
};
